import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/app/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { EyeOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Form, message, Popover, Row, Switch, Tooltip, Typography } from 'antd';
import { getSettingsStore } from 'core/modules/settings/settings.store';
import { useTranslation } from 'react-i18next';
import { formIsTouched } from 'src/utils/form';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var TaskListColumnsPopover = function TaskListColumnsPopover() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getSettingsStore = getSettingsStore(),
      taskColumns = _getSettingsStore.taskColumns,
      saveTaskColumns = _getSettingsStore.saveTaskColumns;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  function hasAnyFieldSelected(form) {
    return Object.values(form.getFieldsValue()).some(Boolean);
  }

  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return saveTaskColumns(values);

            case 3:
              form.resetFields();
              message.success(t('changesSaved'));
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              message.error(t('unknownError'));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  return /*#__PURE__*/_jsx(Popover, {
    getPopupContainer: function getPopupContainer(trigger) {
      return trigger.parentElement;
    },
    trigger: "click",
    autoAdjustOverflow: true,
    arrowPointAtCenter: true,
    placement: "topLeft",
    onOpenChange: function onOpenChange() {
      form.resetFields();
      form.setFieldsValue(taskColumns);
    },
    content: /*#__PURE__*/_jsxs(Container, {
      labelCol: {
        span: 15
      },
      wrapperCol: {
        span: 10
      },
      style: {
        minWidth: 600
      },
      colon: false,
      form: form,
      onFinish: onSubmit,
      initialValues: _objectSpread({}, taskColumns),
      children: [/*#__PURE__*/_jsx(Typography.Title, {
        level: 4,
        children: t('tasksList.columnsSettings')
      }), /*#__PURE__*/_jsxs("div", {
        className: "switches",
        children: [/*#__PURE__*/_jsxs(Row, {
          gutter: 24,
          children: [/*#__PURE__*/_jsxs(Col, {
            span: 8,
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "type",
              label: t('tasksList.columns.type'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "state",
              label: t('tasksList.columns.state'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "reference",
              label: t('tasksList.columns.reference'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "title",
              label: t('tasksList.columns.title'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "description",
              label: t('tasksList.columns.description'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            })]
          }), /*#__PURE__*/_jsxs(Col, {
            span: 8,
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "deadline",
              label: t('tasksList.columns.deadline'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "assignee",
              label: t('tasksList.columns.assignee'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "reviewer",
              label: t('tasksList.columns.reviewer'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "company",
              label: t('tasksList.columns.company'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "labels",
              label: t('tasksList.columns.labels'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            })]
          }), /*#__PURE__*/_jsxs(Col, {
            span: 8,
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "documents",
              label: t('tasksList.columns.documents'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "comments",
              label: t('tasksList.columns.comments'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "incidences",
              label: t('tasksList.columns.incidences'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "createdAt",
              label: t('tasksList.columns.createdAt'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "updatedAt",
              label: t('tasksList.columns.updatedAt'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "closedAt",
              label: t('tasksList.columns.closedAt'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            })]
          })]
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
          gutter: 24,
          children: [/*#__PURE__*/_jsxs(Col, {
            span: 8,
            children: [/*#__PURE__*/_jsx(Typography.Title, {
              level: 5,
              children: t('form.task.type.values.report')
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "reportZone",
              label: t('tasksList.columns.zone'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "reportIsFraud",
              label: t('tasksList.columns.reportIsFraud'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            })]
          }), /*#__PURE__*/_jsxs(Col, {
            span: 8,
            children: [/*#__PURE__*/_jsx(Typography.Title, {
              level: 5,
              children: t('form.task.type.values.homologation')
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "homologationPlateNumber",
              label: t('tasksList.columns.plateNumber'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "homologationChassisNumber",
              label: t('tasksList.columns.chassisNumber'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "homologationClient",
              label: t('tasksList.columns.client'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            })]
          }), /*#__PURE__*/_jsxs(Col, {
            span: 8,
            children: [/*#__PURE__*/_jsx(Typography.Title, {
              level: 5,
              children: t('form.task.type.values.recognition')
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "recognitionPlateNumber",
              label: t('tasksList.columns.plateNumber'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "recognitionChassisNumber",
              label: t('tasksList.columns.chassisNumber'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "recognitionClient",
              label: t('tasksList.columns.client'),
              valuePropName: "checked",
              children: /*#__PURE__*/_jsx(Switch, {})
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        shouldUpdate: true,
        children: function children(form) {
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Button, {
              id: "task-columns-button",
              type: "primary",
              htmlType: "submit",
              disabled: !formIsTouched(form) || !hasAnyFieldSelected(form),
              children: t('save')
            }), !hasAnyFieldSelected(form) && /*#__PURE__*/_jsxs("p", {
              children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Typography.Text, {
                type: "danger",
                children: t('tasksList.noColumnsError')
              })]
            })]
          });
        }
      })]
    }),
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: t('tasksList.columnsSettings'),
      children: /*#__PURE__*/_jsx(Button, {
        children: /*#__PURE__*/_jsx(EyeOutlined, {})
      })
    })
  }, "view");
}; // Styles

var Container = styled(Form).withConfig({
  displayName: "ColumnsPopover__Container",
  componentId: "sc-nuc2uz-0"
})([".ant-collapse{max-height:60vh;overflow-y:auto;margin-right:-16px;}.ant-form-item{margin-bottom:8px;label{font-weight:normal;}}.ant-typography{margin-bottom:1em;}"]);